import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DateTimeFormats from "const/DateTimeFormats";
import React from "react";
import TransactionAmount from "nlib/common/TransactionAmount";
import classNames from "classnames";
import moment from "moment";

const TransactionInfo = ({ className, documentPreviewMode, transactionData, transactionState }) => {
  const {
    type,
    timestamp,
    amount,
    currency,
    account,
    description
  } = transactionData;

  const { category = {} } = transactionState;

  const { uiTexts } = useSelector(getTextsData);

  return (
    <div className={classNames(Css.transactionInfo, documentPreviewMode && Css.documentPreviewMode, className)}>
      <div className={Css.infoWrapper}>
        <div className={Css.mainInfo}>
          {!!timestamp && (
            <div className={Css.timestamp}>
              <Icons.CalendarBlank />
              <span>
                {moment.utc(timestamp).format(DateTimeFormats.DATE_TEXT)}
              </span>
            </div>
          )}
          <TransactionAmount
            className={Css.amount}
            amount={amount}
            type={type}
            currency={currency} />
        </div>
        <div className={Css.additionalInfo}>
          <div className={Css.row}>
            <Icons.CreditCard />
            <span>{uiTexts.account}: {account.name}</span>
          </div>
          <div className={classNames(Css.row, Css.description, !description && Css.warning)}>
            {description ? <Icons.Info /> : <Icons.Warning />}
            <span>{description || `${uiTexts.noBankDescriptionOrMemo} :(`}</span>
          </div>
          {!category?.code && !transactionData.category?.code && !!transactionData.reason && (
            <div className={classNames(Css.row, Css.reason)}>
              <Icons.Chat />
              <span>{transactionData.reason}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(TransactionInfo);
